/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_Cta_Create_LegalInputs */

const cs_templates_empty_cta_create_legal = /** @type {(inputs: Templates_Empty_Cta_Create_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vytvořit právní šablonu`)
};

const en_templates_empty_cta_create_legal = /** @type {(inputs: Templates_Empty_Cta_Create_LegalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create legal template`)
};

/**
* | output |
* | --- |
* | "Create legal template" |
*
* @param {Templates_Empty_Cta_Create_LegalInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_cta_create_legal = /** @type {((inputs?: Templates_Empty_Cta_Create_LegalInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_Cta_Create_LegalInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_cta_create_legal(inputs)
	return cs_templates_empty_cta_create_legal(inputs)
});